<report-header class="ambita-report-header">
  <ambita-logo/>
  <p class="ambita-report-header__date" if="{ opts.date }">
    <strong>Dato: </strong>{ opts.date }
  </p>

  <script>
    import './ambitaLogo.tag';
    import './reportHeader.scss';
  </script>
</report-header>
